module.exports = __webpack_public_path__ + "static/media/CAN events ApprenticeGroup_MayorLoriLightfoot03_CANevent_07-31-19_96dpi_2363.311cdc78.jpg";